import { DOWNLOADS_LIST_QUERY_KEY } from "@entities/downloads/lib/constant";
import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { IBulkPaymentRequest } from "@shared/lib/types/finance";
import { GST_INVOICES_QUERY_KEY } from "../constants";
import { FinanceApprovalService } from "../services/FinanceApprovalService";

export function useBulkPayments() {
  const {
    mutate: bulkPayments,
    isLoading: isBulkPaymentsLoading,
    isSuccess: isBulkPaymentsSuccess,
    variables,
  } = useMutation({
    mutationFn: (data: {
      vendorPaymentsRequests: IBulkPaymentRequest[];
      token: string;
      otp: string;
    }) =>
      FinanceApprovalService.bulkPayments(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: { skipInvalidation: false },

    onSuccess: (c) => {
      setTimeout(() => {
        c.invalidateQueries({ queryKey: [...GST_INVOICES_QUERY_KEY] });
        c.invalidateQueries({ queryKey: DOWNLOADS_LIST_QUERY_KEY });
      }, 1000);
    },
  });

  return {
    bulkPayments,
    isBulkPaymentsLoading,
    isBulkPaymentsSuccess,
    variables,
  };
}
